export default __webpack_public_path__ + "static/media/sparkstorm.760f65eb.png";